import Gradient from "javascript-color-gradient";

export const getColorGradient = (colors: string[], amount: number): string[] => {
  if (!colors?.length) return colors;

  return colors.length < amount
    ? new Gradient()
        .setColorGradient(colors[0], colors[colors.length - 1])
        .setMidpoint(amount)
        .getColors()
    : colors;
};
